import { render, staticRenderFns } from "./MirrorDetailsCard.vue?vue&type=template&id=12d2fc8a&scoped=true&"
import script from "./MirrorDetailsCard.vue?vue&type=script&lang=js&"
export * from "./MirrorDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./MirrorDetailsCard.vue?vue&type=style&index=0&id=12d2fc8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2fc8a",
  null
  
)

export default component.exports